export default __webpack_public_path__ + "_/images/app/manual/manual3-abbda4330b4cd73bd256d145c536ce1c9e57e52f0cf353f19c5a2812957af8ad.png";